import { flags, permissions } from './constants';
import { useFeatureAccess } from './use-feature-access';

/**
 * Determines if the user has access to Bulk Texting.
 *
 * This is a convenience hook that wraps `useFeatureAccess` and checks
 * both feature flags and ACL permissions for Bulk Texting.
 *
 * @returns An object containing access information for Bulk Texting features:
 * - `hasBulkTextAccess`: The user has ACL permissions and the flag is enabled for Bulk Texting
 * - `hasBulkTextFlagEnabled`: The Bulk Texting feature flag is enabled for at least one location
 * - `locationsWithBulkTextAccess`: Location IDs where the user has the ACL and Bulk Texting is enabled
 * - `locationsWithBulkTextEnabled`: Location IDs where the Bulk Texting feature flag is enabled
 */
export const useHasBulkTextAccess = () => {
  const {
    hasAccess: hasBulkTextAccess,
    hasEnabledFlag: hasBulkTextFlagEnabled,
    locationsWithACLAccess: locationsWithBulkTextAccess,
    locationsWithEnabledFlag: locationsWithBulkTextEnabled,
  } = useFeatureAccess(flags.bulkTexting, permissions.bulkTexting);

  return {
    hasBulkTextAccess,
    hasBulkTextFlagEnabled,
    locationsWithBulkTextAccess,
    locationsWithBulkTextEnabled,
  };
};
